module.exports = __webpack_public_path__ + "img/architecture.d45fe5de.png";